import React from 'react';
import { Button, ButtonProps, mergeClasses } from '@fluentui/react-components';
import { ProtectedLink } from '@bingads-webui-campaign-react/protected-link';

import { I18n } from '../types';
import { warningPopupLocalizedMessage } from '../constants';

interface NavigationPopupProps {
  i18n: I18n;
  onNavigation: () => void;
  enabled?: boolean;
  confirmButtonText: string;
  appearance?: ButtonProps['appearance'];
  className?: string;
}

export const NavigationPopup: React.FC<NavigationPopupProps> = ({
  i18n, onNavigation, enabled, confirmButtonText, appearance, className,
}) => {
  const dialogContent = (
    <div>
      <p>{i18n.getString(warningPopupLocalizedMessage.subtitle)}</p>
    </div>);

  return (
    <ProtectedLink
      className={mergeClasses('protected-link-action', className)}
      enabled={enabled}
      i18n={i18n}
      onNavigation={onNavigation}
      dialogProps={{
        title: i18n.getString(warningPopupLocalizedMessage.title),
        confirmText: i18n.getString(_TL_('Exit and discard changes.')),
        content: dialogContent,
        }}
    >
      <Button appearance={appearance || 'primary'}>
        {confirmButtonText}
      </Button>
    </ProtectedLink>
  );
};

NavigationPopup.defaultProps = {
  appearance: undefined,
  className: undefined,
  enabled: false,
};
